import React from 'react';
import serviceBg from '../../assets/traveller.png';
import curveBorder from '../../assets/underline.svg';
import { RiTeamFill } from 'react-icons/ri';
import { BiSearchAlt } from 'react-icons/bi';
import { MdDashboardCustomize } from 'react-icons/md';
import { BsFillCalendar2CheckFill } from 'react-icons/bs';

const Services = () => {
    return (
        <div className='my-16 w-11/12 mx-auto lg:flex items-center'>
            <div className='lg:w-1/2 xl:p-16'>
                <img className='w-full' src={serviceBg} alt="traveller" />
            </div>
            <div className='lg:w-1/2'>
                <div className='mt-8 flex flex-col items-center'>
                    <h1 className='text-3xl font-bold text-center'>Traveling Made Easier</h1>
                    <img className='block w-40' src={curveBorder} alt="curve underline" />
                </div>
                <small className='block px-12 text-center font-semibold'>With tripaide, your travelling plan is made a lot more easier. You can customize you tour plan, budget & schedule. Choose your ideal partners from many top rated interested users.</small>
                <div className='sm:flex sm:flex-wrap sm:justify-center text-center'>
                    <div className='md:w-1/3 mx-8'>
                        <div className='rounded-xl my-2 hover:shadow-2xl cursor-pointer'>
                            <div className='inline-block'>
                                <RiTeamFill className='mx-8 mt-8 mb-2 p-4 text-6xl rounded-xl shadow-xl bg-lime-100 text-lime-600' />
                            </div>
                            <h2 className='text-lg font-semibold'>Group Travels</h2>
                            <small className='block pb-6 px-4'>What's the fun travelling alone? Travel Together.</small>
                        </div>
                    </div>
                    <div className='md:w-1/3 mx-8'>
                        <div className='rounded-xl my-2 hover:shadow-2xl cursor-pointer'>
                            <div className='inline-block'>
                                <BiSearchAlt className='mx-8 mt-8 mb-2 p-4 text-6xl rounded-xl shadow-xl bg-yellow-100 text-yellow-600' />
                            </div>
                            <h2 className='text-lg font-semibold'>Search For Partners</h2>
                            <small className='block pb-6 px-4'>Search for your ideal travelmates by rating.</small>
                        </div>
                    </div>
                    <div className='md:w-1/3 mx-8'>
                        <div className='rounded-xl my-2 hover:shadow-2xl cursor-pointer'>
                            <div className='inline-block'>
                                <MdDashboardCustomize className='mx-8 mt-8 mb-2 p-4 text-6xl rounded-xl shadow-xl bg-orange-100 text-orange-600' />
                            </div>
                            <h2 className='text-lg font-semibold'>Customizable Plans</h2>
                            <small className='block pb-6 px-4'>Make your plans according to your likings.</small>
                        </div>
                    </div>
                    <div className='md:w-1/3 mx-8'>
                        <div className='rounded-xl my-2 hover:shadow-2xl cursor-pointer'>
                            <div className='inline-block'>
                                <BsFillCalendar2CheckFill className='mx-8 mt-8 mb-2 p-4 text-6xl rounded-xl shadow-xl bg-pink-100 text-pink-600' />
                            </div>
                            <h2 className='text-lg font-semibold'>Time & Budget</h2>
                            <small className='block pb-6 px-4'>Make plans according to your budget & schedule.</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;